// ===== Company Resources Module Types =====

// ----- Type Unions -----

export type CompanyResourceCategory =
    | 'Procedure Documents'
    | 'Safety Posters'
    | 'Training Materials'
    | 'Forms & Templates'
    | 'Regulatory Reference';

export type CompanyResourceFileType = 'PDF' | 'Video' | 'Image' | 'Excel' | 'Document';

// ----- GraphQL Model Interface -----

export interface CompanyResource {
    id: string;
    companyId: string;
    title: string;
    description?: string | null;
    category: CompanyResourceCategory;
    fileType: CompanyResourceFileType;
    contentFilePath?: string | null;
    contentUrl?: string | null;
    folderName?: string | null;
    trainingTopicId?: string | null;
    uploadedByUserId?: string | null;
    uploadedByUserName?: string | null;
    createdAt?: string;
    updatedAt?: string;
}

// ----- Constants -----

export const RESOURCE_CATEGORIES: {
    name: CompanyResourceCategory;
    color: string;
}[] = [
        { name: 'Procedure Documents', color: '#3b82f6' },
        { name: 'Safety Posters', color: '#8b5cf6' },
        { name: 'Training Materials', color: '#f59e0b' },
        { name: 'Forms & Templates', color: '#10b981' },
        { name: 'Regulatory Reference', color: '#ef4444' },
    ];

export const FILE_TYPE_MAP: Record<string, CompanyResourceFileType> = {
    '.pdf': 'PDF',
    '.mp4': 'Video',
    '.mov': 'Video',
    '.jpg': 'Image',
    '.jpeg': 'Image',
    '.png': 'Image',
    '.xlsx': 'Excel',
    '.xls': 'Excel',
    '.docx': 'Document',
    '.doc': 'Document',
};

export const TRAINING_CATEGORIES: CompanyResourceCategory[] = [
    'Safety Posters',
    'Training Materials',
];

/** Company catalog of service steps (Resources → Service Procedures). Separate from Service Items. */
export interface ServiceProcedure {
    id: string;
    companyId: string;
    category: string;
    itemName: string;
    /** Same value on every procedure in a category; drives accordion sort. */
    categorySortOrder?: number | null;
    createdByUserId?: string | null;
    createdByUserName?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
}

/** Join: a Service Procedure uses a Service Item consumable. */
export interface ServiceProcedureConsumable {
    id: string;
    companyId: string;
    procedureId: string;
    serviceItemId: string;
    /** Flat-rate quantity for this procedure. UM is the linked Service Item's unitOfMeasure. */
    quantity?: number | null;
    sortOrder?: number | null;
    createdAt?: string | null;
    updatedAt?: string | null;
}
